import { render, staticRenderFns } from "./waybillDiag.vue?vue&type=template&id=2fffb468&scoped=true"
import script from "./waybillDiag.vue?vue&type=script&lang=js"
export * from "./waybillDiag.vue?vue&type=script&lang=js"
import style0 from "./waybillDiag.vue?vue&type=style&index=0&id=2fffb468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fffb468",
  null
  
)

export default component.exports